// Imports ------------------------------------------------------------------->

import {Component} from "../Component";
import {element} from "../CustomElement";

import {inject} from "../../services/di";
import { AuthenticationService } from "../../services/AuthenticationService";
import { ConfigService } from "../../services/ConfigService";
import { icons } from "../../icons/Icons";
import { i18n } from "../../i18n/I18n";
import { Link } from "../flipp-link/Link";
import { LinkService } from "../../services/LinkService";
import { AuthProvider } from "../../definitions/CommonDefinitions";
import { LoginSource } from "../../services/definitions/IAnalyticsService";
import { EventService } from "../../services/EventService";
import { AnalyticsService } from "../../services/AnalyticsService";
import { FormInput } from "../flipp-form-input/FormInput";
import {
	handleFormInputsChange,
	handleLogin,
	handleResendActionRequest,
	handleSubmitRequest,
	setDocumentTitle
} from "./Login.helper";
import { I18nLink } from "../flipp-i18n-link/I18nLink";
import { AccountsService } from "../../services/AccountsService";

@element("flipp-opt-in-page")
export class OptInPage extends Component<{}, void> {

	@inject accounts: AccountsService;
	@inject auth: AuthenticationService;
	@inject config: ConfigService;

	refs: {
		submitForm: HTMLFormElement;
		submitBtn: HTMLElement;
		spinner: HTMLElement;
		submitBtnText: HTMLElement;
		underButtonText: HTMLElement;
		responseErrorMsg: HTMLElement;
	};

	header = "";

	onCreate() {
		this.header = i18n("opt_in_header");
		setDocumentTitle(this.header);
	}

	render() {
		const optInLinks: {[key: number]: string} = {
			1: "https://corp.flipp.com/legal/privacy/",
			2: "https://corp.flipp.com/contact-us/"
		};
		return (
			<main>
				<div class="top-bar" style={{backgroundColor: this.config.getThemeColor()}}>
					<Link to="listing" class="flipp-logo" title="Flipp">
						{icons.flippLogoWhite}
					</Link>
				</div>
				<div class="one-column-content">
					<div class="one-column-picture">
						<img src={`https://f.wishabi.net/creative/Distribution/images/opt-in.svg`} alt="" />
					</div>
					<div class="header">{this.header}</div>
					<div class="one-column-text legal">
						<I18nLink key="opt_in_text" values={JSON.stringify(optInLinks)} />
					</div>
					<div class="one-column-form">
						<div class="button-container">
							<button  ref="submitBtn" class="flipp-button" onClick={this.handleSubmit}>
								<div ref="submitBtnText" class="submit-button-text">{i18n("opt_in_button_text")}</div>
								<div ref="spinner" class="spinner hide"></div>
							</button>
							<p ref="responseErrorMsg" class="error-msg"></p>
						</div>
						<div class="maybe-later" onClick={this.handleMaybeLater}>{i18n("no_thanks")}</div>
					</div>
				</div>
			</main>
		);
	}

	private optIn = async() => {
		const user = this.auth.user.token;
		await this.accounts.updateSubscription(user, true);
		LinkService.getInstance().execute("weekly_ads", this);
	}


	private handleSubmit = async(e: any) => {
		e.preventDefault();
		await handleSubmitRequest(this.refs, this.optIn);
	}

	private handleMaybeLater = (e: any) => {
		e.preventDefault();
		LinkService.getInstance().execute("weekly_ads", this);
	}
}
